export default "__VITE_ASSET__BXpNg8r___"